module.exports = __webpack_public_path__ + "media/images/application/icons/icon-megaphon-black-aa877ebbbe3ac1d8319b614411a40ca7.svg";